export default __webpack_public_path__ + "static/media/left-quotes-sign.925b0eb1.png";